import { fadeInAnimation } from './../../../../../shared/src/lib/_animations/fade-in.animation';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  OilBlockDto,
  OilFieldDto,
  CommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  GMOUDto,
  ProjectDto,
  CurrencyDto,
  ProjectActivityDto,
} from '@cradua/data';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectReferencesService } from '../../services/project-references.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ProjectModalComponent } from 'libs/shared/src/lib/components/project-modal/project-modal.component';

@Component({
  selector: 'mrsoftapps-new-project',
  templateUrl: './new-project.component.html',
  styleUrls: ['./new-project.component.scss'],
  //  // make fade in animation available to this component
  animations: [fadeInAnimation],

  //  // attach the fade in animation to the host (root) element of this component
  host: { '[@fadeInAnimation]': '' },
})
export class NewProjectComponent implements OnInit {
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() projectTypes: ProjectTypeDto[];
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() projectData: ProjectDto;
  @Input() oilBlocks: OilBlockDto[];
  @Input() oilFields: OilFieldDto[];
  @Input() communities: CommunityDto[];
  @Input() selectedGMOUId: string;
  @Input() countries: CountryDto[];
  @Input() clusters: ClusterDto[];
  @Input() clusterCommunity: ClusterCommunityDto[];
  @Input() projectManagements: ProjectDto[];
  @Input() documentCategory: DocumentCategoryDto[];
  @Input() documentSubCategory: DocumentSubCategoryDto[];
  @Input() projectActivities: ProjectActivityDto[];
  @Input() gmous: GMOUDto[];
  @Input() currencies: CurrencyDto[];
  @Output() changeEmit = new EventEmitter<any>();
  @Output() onActivityEmit = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  @Output() deleteActivityEvent = new EventEmitter<any>();

  projectForm: FormGroup;
  selectedGmous: any;
  GmouData: GMOUDto | any;
  status = false;

  users = [
    { id: 1, name: 'Elvis Steve' },
    { id: 2, name: 'Julius Oko' },
  ];
  selectedValue: GMOUDto;
  genericFieldLabel: string;
  genericBlockLabel: string;
  selectedModalItem: any;
  constructor(
    private fb: FormBuilder,
    private projectRefService: ProjectReferencesService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {
    this.getGmouForm();

    if (this.projectData) {
      this.projectForm.patchValue(this.projectData);
      this.selectGMOU(this.projectData.GMOUId);
    }

    if (this.selectedGMOUId) {
      this.selectGMOU(this.selectedGMOUId);
    }
  }

  // ngAfterViewInit(): void {
  //   //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
  //   //Add 'implements AfterViewInit' to the class.
  //  if(!this.projectData) {
  //   this.filterProjectModal();
  //  }

  // }

  onBack() {
    this.taskEmit.emit('list');
  }

  getGmouForm() {
    this.projectForm = this.fb.group({
      GMOUTypeId: [''],
      GMOUCategoryId: [''],
      GMOUId: [''],
      Location: [''],
      Objective: [''],
      Executor: [''],
      StartDate: ['', Validators.required],
      EndDate: ['', Validators.required],
      ProjectTitle: ['', Validators.required],
      Budget: [0, Validators.required],
      BudgetSpent: [0],
      MilestonePayment: [0],
      Milestone: [''],
      Status: ['Pending'],
      OilBlocId: [''],
      OilFieldId: [''],
      StateId: [''],
      LGAId: [''],
      Description: [''],
      CurrencyId: ['', Validators.required],
      id: [''],
    });
  }

  openCreateActivityModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '700px';
    dialogConfig.width = '70%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'createProjectActivity',
      projects: this.projectManagements,
      projectCategories: this.projectCategories,
      projectTypes: this.projectTypes,
      gmous: this.selectedValue,
      projectActivities: this.projectActivities,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (result.type === 'save') {
          this.onActivityEmit.emit(result.formValue);
        }

        if (result.filteredDelete !== null) {
          this.deleteActivityEvent.emit(result.filteredDelete);
        }
      }
    });
  }

  filterProjectModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '400px';
    dialogConfig.width = '30%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'reportSelectOptions',
      projectCategories: this.projectCategories,
      projectTypes: this.projectTypes,
      gmous: this.gmous,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.selectGMOU(result.gmouId);
      }
    });
  }

  /* Handle form errors in Angular 8 */
  public errorHandling = (control: string, error: string) => {
    return this.projectForm.controls[control].hasError(error);
  };

  selectProjectType(event) {
    this.selectedGmous = this.gmous.filter(
      (item) => item.GMOUTypeId === event.value
    );
  }

  selectGMOU(id: string) {
    const value: GMOUDto = this.gmous.find((item) => item.id === id);
    this.selectedModalItem = {
      gmouId: value.id,
      GMOUTypeId: value.GMOUTypeId,
    };

    if (value) {
      this.selectedValue = value;

      this.GmouData = {
        id: value.id,
        GMOUTitle: value.GMOUTitle,
        GMOUDescription: value.GMOUDescription,
        GMOUCategoryId: this.projectRefService.projectCategoryName(
          this.projectCategories,
          value.GMOUCategoryId
        ),
        GMOUTypeId: this.projectRefService.projectTypeName(
          this.projectTypes,
          value.GMOUTypeId
        ),
        Lgas: this.projectRefService.getLgaArray(this.lgas, value.LGAId),
        States: this.projectRefService.getStateArray(
          this.states,
          value.StateId
        ),
        OilBlocks: this.projectRefService.getOilBlockArray(
          this.oilBlocks,
          value.OilBlocId
        ),
        OilFields: this.projectRefService.getOilFieldArray(
          this.oilFields,
          value.OilFieldId
        ),
        NegotiationDate: value.NegotiationDate,
        SignatureDate: value.SignatureDate,
        GMOUId: value.GMOUId,
      };

      if (this.oilFields.length > 0) {
        this.genericFieldLabel = this.oilFields[0].LabelName;
        this.genericBlockLabel = this.oilBlocks[0].LabelName;
      }
      this.status = true;
    }
  }

  getState(id) {
    const selectedLga = this.lgas.find((item) => item.id === id);

    if (!selectedLga) {
      return;
    }

    const selectedState = this.states.find(
      (item) => item.id === selectedLga.StateId
    );

    if (!selectedState) {
      return;
    }

    return selectedState;
  }

  getProjectCategory(id) {
    const selectedType = this.projectTypes.find((item) => item.id === id);
    if (!selectedType) {
      return;
    }

    const selectedCategory = this.projectCategories.find(
      (item) => item.id === selectedType.ProjectCategoryId
    );

    if (!selectedCategory) {
      return;
    }

    return selectedCategory;
  }

  getOilBlock(id) {
    const selectedOilField = this.oilFields.find((item) => item.id === id);
    if (!selectedOilField) {
      return;
    }

    const selectedOilBlock = this.oilBlocks.find(
      (item) => item.id === selectedOilField.OilBlockId
    );

    if (!selectedOilBlock) {
      return;
    }

    return selectedOilBlock;
  }

  onSubmit(formValue: ProjectDto) {
    if (formValue.id) {
      this.changeEmit.emit(formValue);
    } else {
      const selectedProjectType = this.getProjectCategory(
        this.selectedModalItem.GMOUTypeId
      );

      // formValue.StateId = selectedState.id;
      formValue.GMOUCategoryId = selectedProjectType.id;
      formValue.OilBlocId = this.selectedValue.OilBlocId;
      formValue.OilFieldId = this.selectedValue.OilFieldId;
      formValue.StateId = this.selectedValue.StateId;
      formValue.LGAId = this.selectedValue.LGAId;
      formValue.GMOUTypeId = this.selectedModalItem.GMOUTypeId;
      formValue.GMOUId = this.selectedModalItem.gmouId;
      this.changeEmit.emit(formValue);
    }
  }
}
